export default __webpack_public_path__ + "static/media/roadmap_right.aa0da023.png";